import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  Typography,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@mui/material';
import { useHistory } from 'react-router';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import useAuth from 'src/context/AuthContext';
import ROUTE from 'src/utils/routeConstants';
import FMSModal from 'src/common/FMSModal';
import { USER_ROLES } from 'src/utils/constants';

const AccountPopover = (props) => {
  const { anchorEl, onClose, open } = props;
  const history = useHistory();
  const { getUser } = useAuth();
  const user = getUser();
  const isOperator = user?.role === USER_ROLES.operator;
  const [showAlert, setShowAlert] = useState(false);
  const handleAlertClose = () => setShowAlert(false);
  const handleSignOut = () => setShowAlert(true);

  const gotoAccountPage = () => {
    history.push(ROUTE.profile);
    onClose();
  };

  const gotoSettingsPage = () => {
    history.push(ROUTE.settings);
    onClose();
  };

  return (
    <>
      <LogoutModal open={showAlert} onClose={handleAlertClose} />
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom'
        }}
        onClose={onClose}
        open={open}
        slotProps={{ paper: { sx: { width: 200 } } }}
      >
        <Box sx={{ pt: 1.5, pb: 1, px: 2 }}>
          <Typography variant="subtitle2">
            {`${user?.first_name} ${user?.last_name}`}
          </Typography>
          <Typography variant="overline" color="text.secondary">
            {user?.role}
          </Typography>
        </Box>
        <Divider />
        <MenuList
          disablePadding
          dense
          sx={{
            p: '8px',
            '& > *': {
              borderRadius: 1
            }
          }}
        >
          {!isOperator && (
            <MenuItem sx={{ py: 1 }} onClick={gotoAccountPage}>
              <ListItemIcon>
                <ManageAccountsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Account</ListItemText>
            </MenuItem>
          )}
          {!isOperator && (
            <MenuItem sx={{ py: 1 }} onClick={gotoSettingsPage}>
              <ListItemIcon>
                <SettingsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Settings</ListItemText>
            </MenuItem>
          )}
          <MenuItem sx={{ py: 1 }} onClick={handleSignOut}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Sign out</ListItemText>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
};

AccountPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired
};

export default AccountPopover;

export const LogoutModal = ({ open, onClose }) => {
  const { signout } = useAuth();

  return (
    <FMSModal
      open={open}
      maxWidth="xs"
      fullWidth
      onClose={onClose}
      PaperProps={{
        sx: {
          m: { xs: 2, sm: 3 },
          width: { xs: 'calc(100% - 32px)', sm: 'auto' },
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pt: 3, pb: 1 }}>
        Confirm Logout
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ textAlign: 'center' }}>
          Are you sure you want to end your session?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, px: 3 }}>
        <Button variant="outlined" color="inherit" onClick={onClose} sx={{ minWidth: 100 }}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={signout} sx={{ minWidth: 100 }}>
          Logout
        </Button>
      </DialogActions>
    </FMSModal>
  );
};

LogoutModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
